import { Tooltip } from 'bootstrap';

class TooltipManager {
    constructor() {
        this.tooltips = [];
        this.intervalId = null;
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    init() {
        this.setupTooltips();
        this.setupInterval();
        this.setupGlobalClickHandler();
    }

    setupTooltips() {
        const tooltipElements = document.querySelectorAll("[data-bs-toggle='tooltip']");

        tooltipElements.forEach((el) => {
            try {
                if (this.tooltips.some(t => t._element === el)) return;

                const tooltip = new Tooltip(el, {
                    trigger: 'hover focus',
                    container: 'body'
                });

                el.addEventListener('click', () => {
                    tooltip.hide();
                });
                this.tooltips.push(tooltip);
            } catch (ex) {
                console.warn('Tooltip init error:', ex, el);
            }
        });
    }

    setupGlobalClickHandler() {
        document.addEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick(e) {
        this.tooltips.forEach((tooltip) => {
            const el = tooltip._element;
            if (!el) return;

            // Tooltip tetikleyicisi değilse kapat
            if (!el.contains(e.target)) {
                tooltip.hide();
            }
        });
    }

    checkTooltips() {
        this.tooltips = this.tooltips.filter((tooltip) => {
            if (!tooltip._element || !document.body.contains(tooltip._element)) {
                try {
                    tooltip.dispose();
                } catch (ex) {
                    console.warn('Tooltip dispose error:', ex);
                }
                return false;
            }
            return true;
        });
    }

    setupInterval() {
        this.intervalId = setInterval(() => {
            this.setupTooltips();
            this.checkTooltips();
        }, 1000);
    }

    dispose() {
        clearInterval(this.intervalId);
        document.removeEventListener('click', this.handleDocumentClick);

        this.tooltips.forEach((tooltip) => {
            try {
                tooltip.dispose();
            } catch {}
        });

        this.tooltips = [];
    }
}

export default TooltipManager;
